<template>
    <section>
        <div class="recruit_section2" style="display: flex; align-items: center; position: relative;">
            <div class="mobile_con_wrap" style="display: flex; align-items: flex-start; flex-direction: column;">
                <div data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-anchor-placement="center-bottom"
                    data-aos-easing="ease-in-out" style="display: flex; margin: 28px 0 133px 0;">
                    <p style="font-size: 15px; font-weight: 400; color: #5A5A5A; text-align: left; margin-right: 17px">
                        우리는 함께 일하면서 서로 생각하는 바를 끊임없이 나누고 우리의 서비스를 더 좋은 방향으로 발전시키기 위해 더 좋은 아이디어와 의견을 가감없이 말할 수 있는 동료들을 찾고 있습니다. 아무리 사소할지라도 우리는 그 아이디어를 진지하게 받아들일겁니다.
                    </p>
                </div>
                <p style="font-size: 25px; font-weight: 700; color: black; margin-bottom: 46px;">채용절차</p> 
                <div style="display: flex; justify-content: space-between; width: 100%; font-weight: 400; color: #5A5A5A; margin-bottom: 70px;">
                    <div v-for="(item, index) in joinProcess" :key="index" 
                        data-aos="fade"
                        :data-aos-delay="100 * index"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" class="box_join_process" :style="{backgroundColor: item.color}">
                        {{item.text}}
                    </div>
                </div>
                <div data-aos="fade-up"
                        :data-aos-delay="0"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" style="margin-bottom: 64px;">
                    <p style="font-size: 18px; line-height: 1.8; font-weight: 700; color: black;">채용은 서류전형과<br>대면면접으로 이루어집니다.</p>
                    <p style="font-size: 15px; line-height: 1.8; font-weight: 500;">
                        위 내용은 영입을 위한 기본 프로세스로 경우에 따라 추가 절차가 포함될 수 있습니다.<br>
                        최종 합격 시, 합격자에 한해 개별적으로 합격통보 연락을 드립니다.
                    </p>
                </div>
                <div style="width: 100%; max-width: 100%; height: 216px; display: flex; justify-content: space-between;">
                    <div style="width: 25%; overflow: hidden; margin-right: 10px;">
                        <img data-aos="fade"
                            data-aos-delay="0"
                            data-aos-once="true"
                            data-aos-duration="500"
                            data-aos-easing="ease-in-out" src="@/assets/images/main_v2/background_section5-2.jpg" alt="" style="height: 216px; object-fit: left; object-position: center; transform: translateX(-40%);">
                    </div>
                    <div  style="width: 75%; overflow: hidden;">
                        <img data-aos="fade"
                            data-aos-delay="100"
                            data-aos-once="true"
                            data-aos-duration="500"
                            data-aos-easing="ease-in-out" src="@/assets/images/main_v2/background_section5-3.jpg" alt="" style="height: 216px; width: 100%; object-fit: cover; object-position: center;">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    components: {
        ChevronDownIcon,
    },
    data() {
        return {
            joinProcess: [
                {
                    'text': '서류전형',
                    'size': 483,
                    'color' : '#1C9CD3'
                },{
                    'text': '대면면접',
                    'size': 278,
                    'color' : '#1C9CD399'
                },{
                    'text': '결과',
                    'size': 123,
                    'color' : '#1C9CD333'
                },
            ],
            // webUrl: "https://www.pulda.net",
            // appleUrl: "https://apps.apple.com/app/id1530892838",
            // googleUrl:
            //     "https://play.google.com/store/apps/details?id=com.filledu.pulda2",
            // adminEmail: 'admin@filledyou.com',
            // showSnackBar: false,
            // snackbarInfo: {
            //     text: '',
            //     icon: '',
            //     color: '',
            //     background: ''
            // },
        }
    },
    methods: {
        openLink(val) {
            window.open(val, '_blank')
        },
        // copy(val) {
        //     navigator.clipboard.writeText(val).then(()=> {
        //         this.$store.commit('SET_SNACK_BAR_INFO' , {
        //             text: '메일주소가 복사되었습니다.',
        //             icon: 'icon-check.svg',
        //             color: 'white',
        //             background: '#1C9CD3'
        //         })
        //         this.showSnackBar = true
        //     })
        // },
    }
    
}
</script>
<style>
    .recruit_section2 {
        width: 100vw;
        background: white;
        object-fit: inherit;
    }
    .box_join_process {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100%;
        font-weight: 700;
        font-size: 18px;
        color: black; 
        line-height: 1.5; 
        text-align: center;
    }
</style>
<style lang="scss">
    $width: calc((100vw - 72px) / 3);
    .box_join_process {
        width: $width;
        height: $width;
    }
</style>